<template>

    <!-- Modal Below -->
    <Modal title="Change Password"
            :modalShown="modalShown"
            :isValid="inputIsValid"
            v-on:confirm="changePassword"
            v-on:cancel="reset">
        <template v-slot:body>
            <form>
                <div class="mb-4">
                    <label class="block text-gray-700 text-sm font-bold mb-2">

                    </label>
                    <div class="relative">
                        <form>
                            <div class="mb-4 text-center py-10">
                                <img src="../assets/images/security.svg"/>
                            </div>
                            <div class="mb-4">
                                <label class="block text-gray-700 text-sm font-bold mb-2" for="username">
                                    Original Password
                                </label>
                                <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                        type="password"
                                        placeholder="Original Password"
                                        v-model="originalPasswordField">
                            </div>
                            <div class="mb-4">
                                <label class="block text-gray-700 text-sm font-bold mb-2" for="username">
                                    New Password
                                </label>
                                <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                        type="password"
                                        placeholder="New Password"
                                        v-model="newPasswordField">
                            </div>
                            <div class="mb-4">
                                <label class="block text-gray-700 text-sm font-bold mb-2" for="username">
                                    Confirm New Password
                                </label>
                                <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                        type="password"
                                        placeholder="Confirm New Password"
                                        v-model="newPasswordConfirmedField">
                            </div>
                        </form>
                    </div>
                </div>
            </form>
        </template>
    </Modal>

</template>

<script>
import Modal from './Modal.vue';

import {
    mapState,
    mapGetters,
    mapMutations,
    mapActions
} from 'vuex'

export default {

    components: {
        Modal,
    },

    computed: {
        ...mapState(
            'passwordManager',
            [
                'modalShown',
                'originalPassword',
                'newPassword',
                'newPasswordConfirmed'
            ]
        ),
        ...mapGetters(
            'passwordManager',
            [
                'inputIsValid',
            ]
        ),

        originalPasswordField:{
            get() {
                return this.originalPassword;
            },
            set(val) {
                this.setOriginalPassword(val);
            },
        },
        newPasswordField:{
            get() {
                return this.newPassword;
            },
            set(val) {
                this.setNewPassword(val);
            },
        },
        newPasswordConfirmedField:{
            get() {
                return this.newPasswordConfirmed;
            },
            set(val) {
                this.setNewPasswordConfirmed(val);
            },
        }
    },

    methods: {
        ...mapMutations(
            'passwordManager',
            [
                'setOriginalPassword',
                'setNewPassword',
                'setNewPasswordConfirmed',
            ]
        ),
        ...mapActions(
            'passwordManager',
            [
                'changePassword',
                'reset',
            ]
        ),
    },

    destory() {
        this.reset();
    }

}

</script>
